import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    selectedFilterType: { filterType: "All" },
    selectedExpense: null,
    selectedEmployee: null,
    selectedLocation: null,
    selectedUser: null,
    selectedRecordType: { recordType: "without details" },
    fromDate: null,
    toDate: null,
    rawFrom: null,
    rawTo: null,
  },
  list: [],
  details: [],
  filterResult: [],
  filterResultDetails: [],
  loading: false,
  searchResults: [],
  employees: [],
  locations: [],
  users: [],
  loadingSearch: false,
};

const expenseRecordSlice = createSlice({
  name: 'expenseRecord',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setReportData: (state, action) => {
      state.list = action.payload.list || [];
      state.details = action.payload.details || [];
      state.filterResult = action.payload.filterResult || [];
      state.filterResultDetails = action.payload.filterResultDetails || [];
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setEmployees: (state, action) => {
      state.employees = action.payload;
    },
    setLocations: (state, action) => {
      state.locations = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLoadingSearch: (state, action) => {
      state.loadingSearch = action.payload;
    },
    resetState: () => initialState,
  },
});

export const { 
  setFilters, 
  setReportData, 
  setSearchResults, 
  setEmployees, 
  setLocations, 
  setUsers, 
  setLoading, 
  setLoadingSearch, 
  resetState 
} = expenseRecordSlice.actions;
export default expenseRecordSlice.reducer;